//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
			noneList:false,
			addressList: [],
			source: 0,
			choseIndex: 0
		}
	},
	onLoad() {
		this.getList()
	},
	onShow() {
		let refresh = uni.getStorageSync('refresh')
		if (refresh) {
			this.getList()
			uni.setStorageSync('refresh', false)
		}
	},
	methods: {
		del(item) {
			let _this = this
			uni.showModal({
				content: '确认要删除该地址吗？',
				success(res) {
					if (res.confirm) {
						_this.$ajax({
							method: 'post',
							url: '/weChat/specialtyProduct/deletedDeliveryAddress',
							data: {
								deliveryAddressId: item.deliveryAddressId
							}
						}).then(res => {
							uni.showToast({
								title: '删除成功',
								icon: 'none'
							})
							_this.getList()
						})
					}
				}
			})
		},
		//获取收货地址
		getList() {
			this.$ajax({
				method: 'post',
				url: '/weChat/specialtyProduct/queryDeliveryAddressList',
				data: {
					memberId: this.$store.state.userInfo.memberId
				}
			}).then(res => {
				this.addressList = res.data.deliveryAddressList
				this.noneList = this.addressList.length>0?false:true
			})
		},
		editAddress(item) {
			uni.navigateTo({
				url: `/pages/personalCenter/myAddress/detail?id=${item.deliveryAddressId}`
			})
		},
		addAddress(item) {
			uni.navigateTo({
				url: `/pages/personalCenter/myAddress/detail`
			})
		}
	}
}
